<template>
  <div id="headerss">
    <header class="bg-lightblue">
      <div
        class="header_top flex flex-between gWidth align-center"
        style="flex-wrap: wrap"
      >
        <ul class="header_t_l flex">
          <li>
            <a href="http://www.gov.cn/" target="_blank">中央政府</a>
            <span>|</span>
          </li>
          <li>
            <a href="http://baoding.gov.cn/" target="_blank"> 保定市人民政府</a>
          </li>
        </ul>
        <ul class="header_t_r flex">
          <li>
            <a href="javascript:;">设为首页</a>
            <span>|</span>
          </li>
          <li>
            <a href="javascript:(alert('请按Ctrl+D组合键收藏本站'))"
              >收藏本站</a
            >
            <span>|</span>
          </li>
          <li>
            <router-link to="/gaikuang/41">联系我们</router-link>
            <span>|</span>
          </li>
          <li>
            <router-link to="/Search">搜索</router-link>
          </li>
        </ul>
      </div>
    </header>
    <div class="header_bgimg">
      <img :src="'http://' + banner" alt="" style="width: 100%" />
    </div>
    <div class="header_logo gWidth">
     <!-- 右上角两会 2023年5月4日10:11:34-->
      <!-- <p class="lh2023line" opentype="page" setedaria="true"><a class="lh2023" style="float: right;" href="http://www.gov.cn/zhuanti/2023qglh/index.htm" target="_blank"> <img border="0" src="https://www.gov.cn/govweb/xhtml/2019zhuanti/202303pcNationalTwoSessionsZhuanti/images/2023lianghuilogo.png"> </a></p> -->
    </div>
    <div class="nav bg-blue">
      <!-- pc端 -->
      <ul class="flex flex-between gWidth isPc">
        <li>
          <router-link
            to="/"
            class="flex align-center flex-center"
            active-class="active"
            exact
          >
            <img src="@/assets/1shouye.png" class="mid_img" alt="" />
            <span>首 页</span></router-link
          >
        </li>
        <li>
          <router-link
            to="/gaikuang/18"
            class="flex align-center flex-center"
            active-class="active"
          >
            <img
              src="https://www.bdgxq.gov.cn/storage/images/shouye.png"
              class="mid_img"
              alt=""
            />
            <span>高新概况</span></router-link
          >
        </li>
        <li>
          <a
            href="http://bdgx.hbzwfw.gov.cn/"
            target="_blank"
            class="flex align-center flex-center"
          >
            <img
              src="https://www.bdgxq.gov.cn/storage/images/zhengwufuwu.png"
              class="mid_img"
            />
            <span>政务服务</span>
          </a>
        </li>
        <li>
          <a
            href="https://www.bdgxq.gov.cn/zwgk/index.html"
            target="_blank"
            class="flex align-center flex-center"
          >
            <img
              src="https://www.bdgxq.gov.cn/storage/images/zhengwugongkai.png"
              class="mid_img"
            />
            <span>信息公开</span>
          </a>
        </li>
        <li>
          <router-link
            to="/ztzl"
            class="flex align-center flex-center"
            active-class="active"
          >
            <img
              src="https://www.bdgxq.gov.cn/storage/images/zhauntizhuanlan.png"
              class="mid_img"
              alt=""
            />
            <span>专题专栏</span></router-link
          >
        </li>
        <li>
          <router-link
            to="/Gzly"
            class="flex align-center flex-center"
            active-class="active"
          >
            <img
              src="https://www.bdgxq.gov.cn/storage/images/gongzhongliuyan.png"
              class="mid_img"
              alt=""
            />
            <span>公众留言</span></router-link
          >
        </li>
      </ul>
      <!-- pc端end -->
      <!-- 手机端 -->
      <div class="mores">
        <div class="mores_span">
          <span>网站首页</span>
          <span v-for="item in navs" :key="item.id">
            {{ item.name }}
          </span>
          <span>留言</span>
          <span>搜索</span>
          <span>网站地图</span>
          <span>文章</span>
        </div>
        <img
          src="@/assets/more2.png"
          class="mores_img"
          @click="navtwoShow = !navtwoShow"
        />
        <transition name="ul">
          <div class="navtwo ul-box" v-if="navtwoShow">
            <li @click="turnTo2">
              <router-link to="/" class="flex align-center flex-center"
                >网站首页</router-link
              >
            </li>

            <li @click="turnTo2">
              <router-link
                to="/gaikuang/18"
                class="flex align-center flex-center"
              >
                高新概况</router-link
              >
            </li>
            <li @click="turnTo2">
              <a
                href="http://bdgx.hbzwfw.gov.cn/"
                target="_blank"
                class="flex align-center flex-center"
              >
                政务服务
              </a>
            </li>
            <li @click="turnTo2">
              <a
                href="https://www.bdgxq.gov.cn/zwgk/index.html"
                target="_blank"
                class="flex align-center flex-center"
              >
                政务公开
              </a>
            </li>
            <li @click="turnTo2">
              <router-link to="/ztzl" class="flex align-center flex-center">
                专题专栏</router-link
              >
            </li>
            <li @click="turnTo2">
              <router-link to="/Gzly" class="flex align-center flex-center">
                公众留言</router-link
              >
            </li>
          </div>
        </transition>
      </div>
      <!-- 手机端end -->
    </div>
  </div>
</template>
<script>
import { set, gxlanmu } from "@/api/gxq";
export default {
  data() {
    return {
      navs: [],
      banner: "",
      isFalse: false,
      isLoading: true,
      navtwoShow: false,
    };
  },
  mounted() {
    this.getNav();
    // console.log(document.getElementsByTagName("body")[0]);
    if (localStorage.getItem("isfou") && localStorage.getItem("isfou") == 1) {
      document.getElementsByTagName("body")[0].style.filter = "grayscale(100%)";
      this.getSets(1);
    } else if (
      localStorage.getItem("isfou") &&
      localStorage.getItem("isfou") == 0
    ) {
      this.getSets(2);
    } else {
      this.getSets(3);
    }
  },
  methods: {
    async getSets(e) {
      const { data } = await set();
      var isfou = data[0].isfou;
      // isfou = 0;
      // var isfou =
      if (e == 3) {
        //现在是灰的
        localStorage.setItem("isfou", isfou);
        if (isfou == 1) {
          document.getElementsByTagName("body")[0].style.filter =
            "grayscale(100%)";
        }
      } else if (e == 1) {
        //现在是灰的
        if (isfou == 1) {
          // console.log("不做操作,已经是灰色的了");
        } else {
          document.getElementsByTagName("body")[0].style.filter = "";
        }
        localStorage.setItem("isfou", isfou);
      } else if (e == 2) {
        // console.log(document.getElementsByTagName("body"));
        //现在不是灰的
        if (isfou == 1) {
          document.getElementsByTagName("body")[0].style.filter =
            "grayscale(100%)";
          // console.log("变灰");
        } else {
          // console.log('不做操作')
        }
        localStorage.setItem("isfou", isfou);
      }
    },
    async getNav() {
      const { data } = await gxlanmu();

      this.navs = data.nav;
      this.banner = data.banner;
    },
    turnTo2() {
      this.navtwoShow = false;
    },
  },
};
</script>
<style scoped>
.bg-graysss {
  filter: grayscale(100%);
}

[v-cloak] {
  display: none;
}

.show {
  display: none;
}
.ul-box {
  height: 280px;
  overflow: hidden;
}
.ul-enter-active,
.ul-leave-active {
  transition: all 0.5s;
}

.ul-enter,
.ul-leave-to {
  height: 0;
}
.active {
  background-color: var(--primary-dark);
}
</style>
